// 正式
export default {
	env: 'production',
	mock: false,
	title: '生产',
  imgUrl: '',
	baseUrl: '', // 正式项目地址
	baseApi: '', // 正式api请求地址
	// baseApi: 'http://w.qzhlkj.net/vab-mock-server/', // 测试api请求地址
	APPID: 'wxb2b90c3586b41f7d',
	APPSECRET: '',
	$cdn: ''
}
